import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import WhatsAppButton from "@/components/WhatsAppButton";
import Nav from "@/components/Nav";
import { useCurrency } from "@/lib/currency";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Lombok from "@/pages/Lombok";
import Portfolio from "@/pages/Portfolio";
import InvestorClub from "@/pages/InvestorClub";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err) {
    console.error(err);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink font-display text-2xl text-cream">
          Something went wrong.
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const { code } = useCurrency();
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Nav />
          <Routes key={code}>
            <Route path="/" element={<Home />} />
            <Route path="/lombok" element={<Lombok />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/investor-club" element={<InvestorClub />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="bottom-left" />
    </ErrorBoundary>
  );
}

export default App;
